const isJSONString = (value) => {
  if (typeof value !== 'string') return false;
  try {
    const parsed = JSON.parse(value);
    return typeof parsed === 'object' || typeof parsed === 'number' || typeof parsed === 'string' || typeof parsed === 'boolean' || parsed === null;
  } catch (e) {
    return false;
  }
};

export const setLocalStorageMenuItem = (key, value) => {
  const location = window.location.href;
  const array = location.split("/");
  const menuId = array[array.length - 2];

  if (!menuId || !key) return;
  const fullKey = `${menuId}_${key}`;
  const storedValue = isJSONString(value) ? value : JSON.stringify(value);
  localStorage.setItem(fullKey, storedValue);
};

export const getLocalStorageMenuItem = (key) => {
  const location = window.location.href;
  const array = location.split("/");
  const menuId = array[array.length - 2];

  if (!menuId || !key) return null;
  const fullKey = `${menuId}_${key}`;
  const value = localStorage.getItem(fullKey);
  try {
    return JSON.parse(value);
  } catch (err) {
    return value;
  }
};

export const removeLocalStorageMenuItem = (key) => {
  const location = window.location.href;
  const array = location.split("/");
  const menuId = array[array.length - 2];

  if (!menuId || !key) return;
  const fullKey = `${menuId}_${key}`;
  localStorage.removeItem(fullKey);
};
